// extracted by mini-css-extract-plugin
module.exports = {"background-container":"top-companies-notice_background-container__fM7UX","logos":"top-companies-notice_logos___afVs"};